/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/12
 * Time: 15:13
 * Desc: 分销策略设置-导购分销
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';

@Component
export default class GuiderDistribute extends Vue {
  /* 数据 */

  /**
   * 导购分销表单
   * @type {ItemObject}
   */
  public guiderDistributeForm: ItemObject = {
    timeLimit: 0,
    openMemberIdent: 0,
  };

  /**
   * 分销收益时效验证
   * @type {Function}
   */
  public numberRule = (rule, value, callback) => {
    const reg = /^(\d+(\.\d{1,2})?)$/;
    if (value === '') {
      callback(new Error('请输入导购分销收益时效'));
    } else if (!reg.test(value)) {
      callback(new Error('请输入大于0的整数或最多带2位小数的浮点数'));
    } else {
      callback();
    }
  };

  /**
   * 导购分销表单验证规则
   * @type {ItemObject}
   */
  public guiderDistributeFormRules: ItemObject = {
    timeLimit: [{ validator: this.numberRule, trigger: 'blur' }],
  };

  /* 方法 */

  /**
   * 如果用户输入的是0.00*，自动转化为0
   * @param {string} item
   * @return null
   */
  zeroIntig(item): void {
    if (Number(this.guiderDistributeForm[item]) === 0) { this.guiderDistributeForm[item] = 0; }
  }

  /**
   * 提交更新
   */
  public onSubmitInfo(): void {
    (this.$refs.guiderDistributeForm as ElForm).validate((valid) => {
      if (valid) {
        this.updateGroupInfo();
      } else {
        return false;
      }
    });
  }

  /**
   * 更新集团信息
   * @api
   */
  public updateGroupInfo(): void {
    const postParams = {
      shareCacheTime: this.guiderDistributeForm.timeLimit,
      openMemberIdent: this.guiderDistributeForm.openMemberIdent,
    };
    IPSService.updateGroupSet({ postParams }).then((res) => {
      if (res.ret) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /**
   * 获取集团信息
   * @api
   */
  public getGroupInfo(): void {
    IPSService.getGroupSetInfo().then((res) => {
      if (res) {
        this.guiderDistributeForm.timeLimit = res.shareCacheTime;
        this.guiderDistributeForm.openMemberIdent = res.openMemberIdent; // 会员认证(本页面无用)
      } else {
        this.$message.error('获取集团信息失败');
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getGroupInfo(); // 获取集团信息
  }
}
